
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-satisfaction",
      function () {
        return require("private-next-pages/customer-satisfaction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-satisfaction"])
      });
    }
  